/**
 * Phase 9.2 — i18n bootstrap.
 *
 * Uses `i18next-http-backend` to load JSON dictionaries from
 * `/locales/{lng}/{ns}.json` (served from `public/locales/`), with
 * browser language detection falling back to English.
 *
 * The instance is initialised for its side effects; components import
 * `useTranslation()` from `react-i18next` directly.
 */
import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

export const SUPPORTED_LANGUAGES = ["en", "fr", "de"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    ns: ["common"],
    defaultNS: "common",
    debug: false,
    interpolation: { escapeValue: false },
    backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "ckos.lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

export default i18n;
